export default "__VITE_ASSET__CVhHqfOB__"